import { useContext } from 'react';
import { userContext } from '../contexts/userContext';

function useUserInfo() {
	const userInfo = useContext(userContext);
	return userInfo;
}

export default useUserInfo;
